import React from 'react';
import { BASE_PATH } from '../config';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import { AuthContext } from '../components/Layout';
import { postWithToken } from '../utils';

function getPaymentMethodData(paymentMethod) {
  return {
      id: paymentMethod.id,
      exp_month: paymentMethod.card.exp_month,
      exp_year: paymentMethod.card.exp_year,
      last4: paymentMethod.card.last4,
      brand: paymentMethod.card.brand
  }
}

const cardElementOptions = {
  style: {
    base: {
      color: "#000000",
      fontFamily: "'Mukta', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif",
      fontSmoothing: "antialiased",
      fontSize: "18px",
      "::placeholder": {
        color: "#777777",
      }
    },
    invalid: {
      color: "#b73232",
      iconColor: "#d64242",
    },
  },
};

const StripeCardForm = ({ stripeCustomerID, handlePaymentMethodCreated, handleCancelClick }) => {
  const [submitting, setSubmitting] = React.useState(false);
  const [cardError, setCardError] = React.useState('Please enter and save your card information');
  const [touched, setTouched] = React.useState(false);
  const user = React.useContext(AuthContext);
  const stripe = useStripe();
  const elements = useElements();

  function handleChange(event) {
    if (event.error && event.error.message) {
      setCardError(event.error.message);
    }
    else {
      setCardError('');
    }
  }
  const handleSubmit = async (event) => {
    setTouched(true);
    event.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    try {
      setSubmitting(true);
      const result = await stripe.createPaymentMethod({
        type: 'card',
        card: elements.getElement(CardElement),
      });
      if (result.error) {
        setCardError(result.error.message || "Your card could not be saved");
        setSubmitting(false);
      }
      else {
        const paymentMethodData = getPaymentMethodData(result.paymentMethod);
        await postWithToken(user.getIdToken(), `${BASE_PATH}/attachPaymentMethod`, paymentMethodData)
        handlePaymentMethodCreated(paymentMethodData);
      }
    }
    catch(err) {
      setCardError(err.message || "Your card could not be saved");
      setSubmitting(false);
    }
  }
  return (
    <form onSubmit={handleSubmit}>
      <div className={cardError && touched ? 'has-error' : ''}>
        <CardElement options={cardElementOptions} onChange={handleChange} onBlur={() => setTouched(true)} />
      </div>
      {touched && cardError && <div className='error-msg alt-marg'>{cardError}</div>}
      <div className='save-btn-container'>
        {handleCancelClick && !submitting && <div>
          <button type="button" className='btn white-btn small-btn' onClick={handleCancelClick}>CANCEL</button>
        </div>}
        <div>
          <button type="submit" className={`btn small-btn primary-outline-btn${submitting ? ' disabled' : ''}`} disabled={submitting}>
          {submitting ? <span className='saving'>SAVING<span>.</span><span>.</span><span>.</span></span> : <span>SAVE CARD</span>}
          </button>
        </div>
      </div>
    </form>
  )
};

export default StripeCardForm;